import e, { useRef as F } from "react";
import L from "classnames";
import t from "./index251.mjs";
import { Typography as g } from "./index24.mjs";
import { ButtonSizes as x, ButtonVariants as y, ButtonWidths as B } from "./index252.mjs";
import { Flex as O } from "./index8.mjs";
import { Icon as f } from "./index10.mjs";
import { FLEX_ALIGN_ITEMS as S, FLEX_JUSTIFY_CONTENT as h } from "./index157.mjs";
import { TYPOGRAPHY_WEIGHTS as U } from "./index168.mjs";
import { ICON_SIZES as Y } from "./index158.mjs";
const $ = ({
  variant: a,
  size: r,
  classes: n,
  width: o,
  colorIcon: s
}) => L(
  t.button,
  t[`${a}`],
  t[`${r}`],
  t[`${o}`],
  s && t[`${a}--color-icon`],
  n
), j = ({
  "data-qa": a = "",
  "data-testid": r = "button",
  classes: n,
  disabled: o = !1,
  iconL: s,
  iconR: l,
  label: m,
  name: E,
  onClick: p,
  size: T = x.DEFAULT,
  variant: N = y.PRIMARY,
  width: I = B.AUTO,
  blurAfterClick: d = !0,
  ellipsis: C = !1,
  style: _ = {},
  colorIcon: b = !0,
  iconSize: c = Y.DEFAULT
}) => {
  const i = F(null), R = $({ variant: N, size: T, classes: n, width: I, colorIcon: b }), A = () => {
    var u;
    o || (p(), d && ((u = i.current) == null || u.blur()));
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      "aria-label": E,
      className: R,
      "data-qa": a,
      "data-testid": r,
      disabled: o,
      onClick: A,
      ref: i,
      tabIndex: 0,
      type: "button",
      style: _
    },
    /* @__PURE__ */ e.createElement(
      O,
      {
        classes: t.content,
        alignItems: S.CENTER,
        justifyContent: h.CENTER
      },
      s ? /* @__PURE__ */ e.createElement(f, { classes: t.iconL, size: c, name: s }) : null,
      m ? /* @__PURE__ */ e.createElement(
        g,
        {
          classes: t.label,
          weight: U.BOLD,
          text: m,
          margin: "3px 0 0 0",
          ellipsis: C
        }
      ) : null,
      l ? /* @__PURE__ */ e.createElement(f, { classes: t.iconR, size: c, name: l }) : null
    )
  );
};
export {
  j as Button,
  x as ButtonSizes,
  y as ButtonVariants,
  B as ButtonWidths,
  j as default
};
